import { createContext, useState } from "react";
import {
  IOrderFunctions,
  OrderTableReport,
  OrderTableSearchParam,
  OrderType,
} from "../../../Interfaces/orderInterfaces";
import {
  getOrderTable,
  orderBulkCancel,
} from "../../../Requests/Order/orderRequests";
import TableTemplate from "../../TableTemplate/tableTemplate";
import OrderTableUI from "./OrderTableUI";
import { toast } from "react-toastify";
import FullScreenLoading from "../../../Components/Loading/FullScreenLoading";
import { AddOrderFormValues } from "../../../Interfaces/callOptionsInterfaces";
import { packetErrorHandler } from "../../../Utils/requestUtils";

export const OrderTableContext = createContext({
  orderType: OrderType.BCSOrder,
  orderFunctions: {} as IOrderFunctions,
}); //initial value doesn't matter

interface OrderTableProps {
  orderType: OrderType;

  searchParam: OrderTableSearchParam;
  orderFunctions: IOrderFunctions;
}

const OrderTable = ({
  searchParam,
  orderType,
  orderFunctions,
}: OrderTableProps) => {
  const [loading, setLoading] = useState(false);

  const orderTableBulkCancelHandler = (selectedRowsIds: number[]) => {
    setLoading(true);
    orderBulkCancel(selectedRowsIds, orderFunctions)
      .then((resp) => {
        orderFunctions.updateOrderTable();
        toast.success(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const onTableRowClick = (row: OrderTableReport) => {
    orderFunctions.setAddOrderFormValues({
      ...orderFunctions.getSlice()?.addOrderFormValues,
      buyInsCode: row?.buyInstrument || "",
      sellInsCode: row?.sellInstrument || "",
    } as AddOrderFormValues);
  };

  return (
    <div className="overflow-auto order-table">
      {loading ? <FullScreenLoading /> : <></>}
      <TableTemplate<OrderTableSearchParam, OrderTableReport>
        refreshTableTime={5000}
        withSort
        getDataTable={(
          searchParam,
          offset,
          pageSize,
          sortingType,
          additional,
          axiosOptions
        ) =>
          getOrderTable(
            searchParam,
            offset,
            pageSize,
            orderFunctions,
            sortingType || "",
            additional,
            axiosOptions
          )
        }
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <OrderTableContext.Provider
            value={{
              orderType,
              orderFunctions,
            }}
          >
            <OrderTableUI
              reports={reports}
              onAction={onAction}
              onTableRowClick={onTableRowClick}
              sortingType={sortingType}
              setSortingType={setSortingType}
              onBulkCancelClick={orderTableBulkCancelHandler}
            />
          </OrderTableContext.Provider>
        )}
        searchParameters={searchParam}
        showPageSize
      />
    </div>
  );
};

export default OrderTable;
